import { render, staticRenderFns } from "./input-phone-number.vue?vue&type=template&id=0e2efe97&"
import script from "./input-phone-number.vue?vue&type=script&lang=js&"
export * from "./input-phone-number.vue?vue&type=script&lang=js&"
import style0 from "./input-phone-number.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports